import { createLocale } from "./createLocale";

export const fi = createLocale({
  header: {
    title: "Tavoita maailma. 2 $ per short-video. Millä tahansa kielellä!",
    subtitle: "🔥Maksa vain tuloksista – $0.089:sta $0.009:ään sekunnilta🔥",
  },
  steps: {
    uploadVideo: "Lataa video",
    selectLanguages: "Valitse kielet",
    conversionResult: "Muunnos ja tulos",
  },
  upload: {
    dragAndDrop: "Vedä ja pudota videotiedostosi tähän",
    orClickToSelect: "tai klikkaa valitaksesi",
    supportedFormats: "Tuetut muodot: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Tiedoston enimmäiskoko: 200 MB",
    maxDuration: "• Enimmäiskesto: 30 s",
    chooseFile: "Valitse tiedosto",
    selectedFile: "Valittu tiedosto:",
    size: "Koko:",
    fileTypeError: "Valitse videotiedosto",
    fileSizeError: "Tiedoston koko ({size} MB) ylittää enimmäisrajan 200 MB",
    durationError: "Videon kesto ({duration} s) ylittää enimmäisrajan 30 s",
    fileReadError: "Videotiedostoa ei voi lukea. Kokeile toista tiedostoa.",
  },
  languages: {
    sourceAudioLanguage: "Lähdeäänen kieli",
    targetAudioLanguage: "Kohdeäänen kieli",
    selectLanguage: "Valitse kieli...",
  },
  conversion: {
    replaceAudio: "Kloonaa ääneni",
    uploadVideoAndSelectLanguages: "Lataa video ja valitse kielet jatkaaksesi",
  },
  nav: {
    blog: "Blogi",
  },
  footer: {
    privacyPolicy: "Tietosuojakäytäntö",
    termsOfUse: "Käyttöehdot",
  },
  languageOptions: {
    fi: "Suomi",
  },
});
